import { useMemo } from 'react'
import { useOfferList } from 'hooks/Offers/useOfferList'
import useOffers from 'hooks/Offers/useOffers'

export default function useSearchMapResults(filters: App.OfferListFilters) {
  const [offerList] = useOfferList(filters)

  const [offers] = useOffers<App.Offer | App.BedbankOffer>(offerList.offerIds)

  const totalNumOffers = offerList.offerIds.length

  const fetchingList = offerList.fetching

  const error = offerList.error

  const offersLoaded = !fetchingList && !error

  const allOffersLoaded = !fetchingList && offers.length === totalNumOffers

  const noOffersAvailable = !fetchingList && offerList.offerIds.length === 0

  const result = useMemo(() => ({
    offers,
    totalNumOffers,
    fetchingList,
    error,
    offersLoaded,
    allOffersLoaded,
    noOffersAvailable,
  }), [
    offers,
    totalNumOffers,
    fetchingList,
    error,
    offersLoaded,
    allOffersLoaded,
    noOffersAvailable,
  ])

  return result
}
